import React, { useEffect, useState } from 'react';
import Services from '../Services/Services';
import './service.css';

const Service = () => {
    const [service,setservice]= useState([]);
    useEffect(()=>{
        fetch('service.json')
        .then(res=>res.json())
        .then(data =>setservice(data));
 
    },[])
    return (
        <div className='container'>
            <div className="row">
            <h1 className='text-primary text-center mt-5 pt-5 pb-4'> Our Services</h1>
            <div className="services-container">
            {
                service.map(serve => <Services
                    key={serve.id}
                    serve={serve}
                >
                </Services>)
            }

           
            </div>
            </div>
           
        </div>
    );
};

export default Service;